import { useState } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import SplashScreen from './components/SplashScreen';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Services from './pages/Services';
import ContactUs from './pages/ContactUs';
import ServiceDetails from './pages/ServiceDetails';
import ArchitectureDesign from './pages/ServicesDetails/ArchitectureDesign';
import BuildingConstruction from './pages/ServicesDetails/BuildingConstruction';
import LayoutPlanning from './pages/ServicesDetails/LayoutPlanning';
import TDRConsultancy from './pages/ServicesDetails/TDRConsultancy';
import GovernmentSchemes from './pages/ServicesDetails/GovernmentSchemes';

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LayoutRegularisationScheme from './pages/ServicesDetails/LayoutRegularisationScheme';

function App() {
  const [showSplash, setShowSplash] = useState(true);

  const handleSplashFinish = () => {
    setShowSplash(false);
  };

  return (
    <div className="App">
      <ToastContainer />
      {showSplash && <SplashScreen onFinish={handleSplashFinish} />}
      {!showSplash && <Header />}
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/home' element={<Home />} />
        <Route path='/About-Us' element={<AboutUs />} />
        <Route path='/Services' element={<Services />} />
        <Route path='/ServiceDetails' element={<ServiceDetails />} />
        <Route path='/Architecture' element={<ArchitectureDesign />} />
        <Route path='/Building' element={<BuildingConstruction />} />
        <Route path='/Layout' element={<LayoutPlanning />} />
        <Route path='/TDR' element={<TDRConsultancy />} />
        <Route path='/BPS' element={<GovernmentSchemes />} />
        <Route path='/LRS' element={<LayoutRegularisationScheme />} />
        <Route path='/Contact-Us' element={<ContactUs />} />
      </Routes>
      <Footer />
    </div>
  );
}


{/* <Route path='/ArchitectureDesign' element={<ArchitectureDesign />} />
        <Route path='/BuildingConstruction' element={<BuildingConstruction />} />
        <Route path='/LayoutPlanning' element={<LayoutPlanning />} />
        <Route path='/TDRConsultancy' element={<TDRConsultancy />} />
        <Route path='/GovernmentSchemes' element={<GovernmentSchemes />} />
        <Route path='/LayoutRegularisationScheme' element={<LayoutRegularisationScheme />} /> */}

export default App;
